export default {"src":"/_next/static/media/grey-check-icon.70a58132.svg","height":7,"width":10};